<template>
  <div class="users f-c-b f-d-c w-100 h-100 p-4 pb-22 o-f-a">
    <div class="myusers f-c-b f-d-c w-100 p-3 h-100">
      <div
        id="financeReport"
        class="w-100 f-c-s f-d-c mt-4"
        style="padding-bottom: 4rem"
      >
        <div class="title f-c-c w-100 mb-4" style="color: #125488">
          گزارش مالی
        </div>
        <div class="tableSec w-100">
          <b-table
            id="table-transition-example"
            :items="items"
            :fields="fields"
            bordered
            hover
            striped
            show-empty
            responsive
            primary-key="a"
            :tbody-transition-props="transProps"
          >
            <template slot="custom-foot" v-if="items.length">
              <b-tr class="footerTr">
                <b-td colspan="3" class="t-a-c">{{ total.title }}</b-td>
                <b-td>{{ total.duration }}</b-td>
                <b-td>{{ total.user_num }}</b-td>
                <b-td>{{ total.price }}</b-td>
              </b-tr>
            </template>
            <template #empty>
              <div
                class="f-c-c animate__animated animate__zoomIn animate__delay-1s w-100 p-5 f-18"
              >
                موردی یافت نگردید.
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="gapMaterial f-c-c w-100">
        <div class="text blueText f-c-c">
          کلیه حقوق مادی و معنوی متعلق به دانشگاه آزاد اسلامی واحد الکترونیکی می
          باشد.
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Accounting",
  data() {
    return {
      total: {},
      transProps: {
        // Transition name
        name: "flip-list",
      },
      items: [],
      fields: [
        { key: "a", label: "ردیف", sortable: true },
        { key: "b", label: "عنوان جلسه", sortable: true },
        { key: "c", label: "زمان شروع", sortable: true },
        { key: "d", label: "مدت زمان", sortable: true },
        { key: "e", label: "تعداد اعضا", sortable: true },
        { key: "f", label: "مبلغ(تومان)", sortable: true },
      ],
    };
  },
  created() {
    this.getAllFinanceDataFunction({
      user_id: this.user.user_id,
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      financeData: (state) => state.gap.financeData,
    }),
  },
  components: {},
  methods: {
    ...mapActions("gap", ["getAllFinanceDataFunction"]),
  },
  watch: {
    financeData(n) {
      if (Object.keys(n).length && n.code == 100) {
        if (n.finance_data.length && this.user.permissions.finance) {
          this.total = n.total;
          this.isTable = true;
          for (let i = 0; i < n.finance_data.length; i++) {
            this.items.push({
              a: i + 1,
              b: n.finance_data[i].title,
              c: n.finance_data[i].start_time,
              d: n.finance_data[i].duration,
              e: n.finance_data[i].user_num,
              f: n.finance_data[i].price,
            });
          }
        } else {
          this.isTable = false;
        }
      }
    },
  },
  mounted() {},
};
</script>